<template>
  <section class="infoBar" v-if="aluno">
    <header>
      <h5>Central do Aluno</h5>
      <h2 class="nome">
        {{ aluno.Basicos.nome.toLowerCase() }}
        <a href="#" class="editPessoaLink" title="Editar Pessoa" @click.prevent="$emit('openModalEditPessoa', aluno.Basicos.idPessoa, 'BasicAluno')">
          <fa :icon="['far','user-pen']" class="icon" />
        </a>
      </h2>
      <p>{{ aluno.Aluno.emailAcademico }}</p>
      <div class="rWrap">
        <span>
          <p>RM</p>
          <h5>{{ aluno.Aluno.rm }}</h5>
        </span>
        <span>
          <p>RA</p>
          <h5>{{ aluno.Aluno.ra }}</h5>
        </span>
      </div>
      <div class="studentPhoto">
        <button
          type="button"
          class="pic"
          :disabled="photoUploading"
          :aria-label="photoUploading ? 'Atualizando foto do aluno' : 'Alterar foto do aluno'"
          @click="openPhotoPicker"
        >
          <img
            :src="alunoPic()"
            :alt="`Foto de ${aluno.Basicos.nome}`"
            @error="photoLoadError = true"
          >
          <span v-if="photoUploading" class="photoLoading" aria-live="polite">
            Salvando...
          </span>
          <span v-else class="photoAction">
            <fa :icon="['far', 'camera']" />
            Alterar foto
          </span>
        </button>
        <input
          ref="photoInput"
          class="photoInput"
          type="file"
          accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
          @change="handlePhotoUpload"
        >
      </div>
    </header>
    <!-- <div>
      <div v-if="perfilPedagogico">
        <div>
          <fa :icon="['far', 'id-card']" class="i"/>
          <h5>Perfis</h5>
        </div>
        <nav>
          <a href="#" class="btn btn-bg btn-small" v-for="profile in matricula.perfislPessoa" :key="profile" @click.prevent="toggleActiveProfile(profile)">{{ profile.nome }}</a>
        </nav>
      </div>
      <div v-if="activeProfile" class="activeProfile">
        <h5>Perfil {{ activeProfileName  }}</h5>
        <textarea-control v-model="activeProfile" textonly></textarea-control>
      </div>
    </div> -->
    <div class="contactInfo">
      <ul>
        <li class="labeledDetail">
          <label>Nascimento</label>
          <p>{{ aluno.Basicos.dataNascimento }}</p>
        </li>
        <li class="labeledDetail" v-if="aluno.Documento">
          <label>RG</label>
          <p>{{ aluno.Documento.rg ?? '...' }}</p>
        </li>
        <li class="labeledDetail" v-if="aluno.Documento">
          <label>CPF</label>
          <p>{{ aluno.Documento.cpf ?? '...' }}</p>
        </li>
      </ul>
      <ul v-if="aluno.Endereco">
        <li class="labeledDetail">
          <label>Endereço</label>
          <p>{{ resolveAddress(aluno.Endereco) }}</p>
        </li>
      </ul>
    </div>
    <div>
      <filiacao :aluno="aluno" v-if="aluno" />
    </div>
    <div>
      <ficha-saida :aluno="aluno" v-if="aluno" @onToggleEdit="toggleEdit($event,'fichaSaida')" ref="fichaSaida" />
    </div>
    <div>
      <ficha-saude :aluno="aluno" v-if="aluno" @onToggleEdit="toggleEdit($event, 'fichaSaude')" ref="fichaSaude" />
    </div>
  </section>
</template>

<script>
import { formatDate } from '@/services/utils.service.js'
import Filiacao from '@/components/centralaluno/utilities/Filiacao.vue'
import FichaSaida from '@/components/centralaluno/utilities/FichaSaida.vue'
import FichaSaude from '@/components/centralaluno/utilities/FichaSaude.vue'
import MatriculaService from '@/services/matricula.service.js'

export default {
  components: {
    Filiacao, FichaSaida, FichaSaude
  },
  props: {
    aluno: {
      type: Object
    }
  },
  data () {
    return {
      photoUploading: false,
      photoLoadError: false
    }
  },
  methods: {
    formatDate ( date ) {
      return formatDate(date)
    },
    resolveAddress ( data ) {
      const logradouro = data.logradouro ?? '[sem logradouro]'
      const numero = data.numero ?? '[sem número]'
      const complemento = ' - ' + data.complemento ?? ''
      const bairro = data.bairro ?? '[sem bairro]'
      const cep = data.cep ?? '[sem cep]'
      const cidade = data.nomeCidade ?? '[sem cidade]'
      const uf = data.nomeUf ?? '[sem UF]'
      
      return `${logradouro}, ${numero}${complemento} - ${bairro} - ${cep} - ${cidade}/${uf}`
    },
    alunoPic () {
      if ( this.aluno.Basicos.urlFoto && !this.photoLoadError ) {
        return this.aluno.Basicos.urlFoto
      } else {
        const src = '/img/'
        return src + ( this.aluno.Basicos.sexo == 'F' ? 'avatar_manu.jpg' : 'avatar_rafinha.jpg') 
      }

    },
    openPhotoPicker () {
      if ( !this.photoUploading ) this.$refs.photoInput.click()
    },
    handlePhotoUpload ( event ) {
      const file = event.target.files[0]
      event.target.value = ''

      if ( !file ) return

      const acceptedTypes = ['image/jpeg', 'image/png', 'image/webp']

      if ( !acceptedTypes.includes(file.type) ) {
        window.toaster.emit('open', {
          style: 'error',
          message: 'Selecione uma foto JPG, PNG ou WEBP.',
          floater: true
        })
        return
      }

      if ( file.size > 5 * 1024 * 1024 ) {
        window.toaster.emit('open', {
          style: 'error',
          message: 'A foto deve ter no máximo 5 MB.',
          floater: true
        })
        return
      }

      this.photoUploading = true

      MatriculaService.updateAlunoFoto(this.aluno.Basicos.idPessoa, file).then(
        response => {
          this.photoLoadError = false
          this.$emit('photoUpdated', response.data.data.urlFoto)
          window.toaster.emit('open', {
            style: 'success',
            message: response.data.message,
            floater: true
          })
        },
        error => {
          window.toaster.emit('open', {
            style: 'error',
            message: error?.response?.data?.message || 'Não foi possível atualizar a foto do aluno.',
            floater: true
          })
        }
      ).finally(() => {
        this.photoUploading = false
      })
    },
    toggleEdit (e, target) {
      this.$emit('onToggleEdit', { e, target } )
    }
  }
}
</script>

<style lang="scss" scoped>
  .infoBar {
    // min-height: 100%;

    > header {
      padding: $hmg_mid;
      padding-right: 160px;
      min-height: 180px;
      box-sizing: border-box;
      border-bottom: $border-component;
      position: relative;
      position: sticky; top: 0;
      z-index: 100;
      background-color: $color-secondary;
      
      >h5 {
        color: $color-primary;
      }
      .nome {
        text-transform: capitalize;

        .editPessoaLink {
          display: inline-flex;
          align-items: center;
          margin-left: $hmg_mini;
          color: $color-text;
          line-height: 1;
          vertical-align: baseline;

          .icon {
            font-size: $font-size-large;
          }

          &:hover {
            color: $color-primary;
          }
        }

      }

      .rWrap {
        display: flex; align-items: center;
        gap: $mg_mini; margin-top: $mg_mini;

        span {
          display: flex; align-items: center; align-content: center;
          justify-content: space-between;
          padding: $mg_mini;
          background-color: $color-bg;
          border-radius: $border-radius;
          gap: $hmg;
          line-height: 1;

          p {
            font-weight: bold;
            margin: 0; padding: 0;
          }
          h5 {
            margin: 0; padding: 0;
          }
        }
      }

      .studentPhoto {
        position: absolute; top: $hmg_mid;
        right: 0; transform: translateX(24px);
      }

      .pic {
        display: block;
        width: 120px; height: 150px;
        padding: 0;
        overflow: hidden;
        position: relative;
        border-radius: $border-radius-large;
        border: $border-component;
        background-color: $color-secondary;
        cursor: pointer;

        img {
          display: block;
          width: 100%; height: 100%;
          object-fit: cover;
          object-position: center top;
        }

        .photoAction,
        .photoLoading {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: $hmg_mini;
          width: 100%;
          min-height: 32px;
          padding: $hmg_mini;
          position: absolute;
          right: 0; bottom: 0;
          box-sizing: border-box;
          border-top: $border-component;
          background-color: $color-secondary;
          color: $color-primary;
          font-size: $font-size-small;
          font-weight: 600;
        }

        .photoLoading {
          top: 0;
          min-height: 100%;
          color: $color-text;
          background-color: $color-bg-transparent;
        }

        &:hover:not(:disabled) .photoAction,
        &:focus-visible .photoAction {
          background-color: $color-primary;
          color: $color-secondary;
        }

        &:focus-visible {
          outline: 2px solid $color-primary;
          outline-offset: 2px;
        }

        &:disabled {
          cursor: wait;
        }
      }

      .photoInput {
        width: 1px; height: 1px;
        overflow: hidden;
        position: absolute;
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        white-space: nowrap;
      }

      @media screen and (max-width: 1024px) {
        .studentPhoto {
          transform: none;
        }
      }

      @media screen and (max-width: 640px) {
        padding-right: $hmg_mid;

        .studentPhoto {
          width: 120px;
          margin-top: $hmg_small;
          position: static;
        }
      }
    }

    > div {
      padding: $hmg_mid;
      border-bottom: $border-component;
      position: relative; z-index: 99;

      &:last-child {
        border-bottom: 0
      }
    }

    .contactInfo {
      ul {
        padding: 0; margin: 0;
        display: flex; align-items: flex-start; align-content: flex-start;
        gap: $mg;

        li {
          list-style: none;
          padding: 0; margin: 0 0 $hmg_small;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .labeledDetail {
      label {
        font-size: $font-size-small;
        font-weight: bold;
        padding: 0; margin: 0 0 $hmg_mini 0
      }
      p {
        margin: 0; padding: 0;
      }
    }
  }
</style>
